import { LoadingService } from '../../shared/services/loading.service';
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError, Subject } from 'rxjs';
import { AuthHttp } from './token.service';
import { AuthenticationService } from './authentication.service';
import { switchMap, catchError, finalize, filter, take} from 'rxjs/operators';
import {throwError as observableThrowError } from 'rxjs';
import { GlobalConfig } from 'app/shared/constant/app.constant';
import swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    isRefreshingToken = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private _refreshSubject: Subject<any> = new Subject<any>();
    private authService;
    private authHttp;
    private loadingService;
    constructor(
        private injector: Injector,
        private router: Router
        ) {

        }


    intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent
     | HttpResponse<any> | HttpUserEvent<any>> {
      this.authService = this.injector.get(AuthenticationService);
      this.loadingService  = this.injector.get(LoadingService);
      if (req.url.includes('refresh') ||
       ((req.url.includes('token') && !req.url.includes('auth/token'))) ||
       req.url.includes('auth/token') ||
      req.url.includes('config/app.config') ||
       !this.authService.isUserLoggedIn()
      ) {
        if (this.authService.getUserInfo()) {
          let activitiesFromStorage = JSON.parse(window.sessionStorage.getItem("userActivities"));
          let encryptedActivities = JSON.parse(atob(window.sessionStorage.getItem("encrypt")));

          //console.log('activities...', activitiesFromStorage, encryptedActivities);

          //debugger;
          if (activitiesFromStorage.length !== encryptedActivities.length) {
            this.authService.logOffSystem().subscribe((res: any) => {
            }, (err) => {
            });
            const redirectUrl = this.authService.redirectUrl;
            // const lastLoggedInUser = this.authService.getLastLoggedInUser();
            this.authService.removealliteminlocalStore();
            // this.authService.setLastUsername(lastLoggedInUser);
            swal(`${GlobalConfig.APPLICATION_NAME}`, 'Invalid session detected, kindly login again', 'info');
            this.router.navigate(['/auth/login'], {
              queryParams: { returnUrl: redirectUrl }
            });
          }
        }
        
        return next.handle(req).pipe( 
          catchError((error, caught) => {
          if (req.url.includes('refresh') || (typeof req.body === 'string' && req.body.includes('refresh_token')) ||
          req.body.includes('token') || req.url.includes('token')
          ) {
            if(error.status == 0 || error.status == 504 || error.status === 505) {
              this.loadingService.hide();
             return throwError({msg: 'Network error. Please check your internet connection'});
            }
          //   this.authService.authenticating = false;
          //   this.authService.resetAuth$.next(error);
          //  this.authService.lockScreen$.next(error);
            this.loadingService.hide();
            return throwError(error);
          } 
          
          else {
            return throwError(error);
        }

      }));
    }



        // if (
        //     nextTokenRefreshTime &&
        //     nextTokenRefreshTime < moment()
        //     && !this.isRefreshingToken) {
        //     console.log('refresh token time expired');
        //     return this.handle401Error(req, next)
        //     .catchError(error => {
        //       // If there is an exception calling 'refreshToken', bad news so logout.
        //       console.log('bounce user out, error caught in token refresh');
        //       this.authService.bounceUserOut();
        //       return  observableThrowError('token error');
        //   });
        // }
      return  next.handle(this.addToken(req)).pipe(
            catchError((error, caught) => {
              if (req.url.includes('refresh')) {
                this.authService.lockScreen$.next(error);
                return  throwError(error);
            }


              console.log(error);
              if (error instanceof HttpErrorResponse) {
                if (error.status === 401 || error.status === 403 ||
                   error.statusText.includes('Unauthorized') ||
                   error.statusText.includes('invalid_grant') ||  error.message.includes('invalid_grant')) {
                  // if (this.isRefreshingToken) {
                  //   // If refreshTokenInProgress is true, we will wait until refreshTokenSubject has a non-null value
                  //   // – which means the new token is ready and we can retry the request again
                  //   return this.tokenSubject
                  //   .pipe(filter(result => result !== null),
                  //   take(1),
                  //   switchMap(() => next.handle(this.addToken(req))));
                  //       // .filter(result => result !== null)
                  //       // .take(1)
                  //       // .switchMap(() => next.handle(this.addAuthenticationToken(request)));
                  // } else {
                  //   this.isRefreshingToken = true;
                  //   this.tokenSubject.next(null);
                  //   this.authService.refreshExpiredToken()
                  //   .subscribe((token) => {
                  //     this.isRefreshingToken = false;
                  //     this.tokenSubject.next(token);
                  //     return next.handle(this.addToken(req));
                  //   }, (err) => {
                  //     this.authService.lockScreen$.next(err);
                  //     this.isRefreshingToken = false;
                  //     return  throwError(err);
                  //   });

                  // }

                  return this._ifTokenExpired().pipe(
                    switchMap(() => {
                      return next.handle(this.addToken(req));
                      // return next.handle(this.updateHeader(req));
                    })
                  );
                } else if (error.status === 0 ) {
                  this.authService.lockScreen$.next(error);

                } else {
                  return  throwError(error);
                }
                          //  return this.handle401Error(req, next);


        }  else {
          return caught;
        }
      })
      );
    }


addToken(req: HttpRequest<any>, _token?: string): HttpRequest<any> {
        this.authService = this.injector.get(AuthenticationService);
        this.authHttp = this.injector.get(AuthHttp);
        const token = _token ? _token : this.authService.getToken();
        return req.clone({ setHeaders: { Authorization: 'Bearer ' + token }});
       // return req.clone({ headers: req.headers.append('Authorization', 'Bearer ' + token)});
    }

handle401Error(req: HttpRequest<any>, next: HttpHandler) {
        this.authService = this.injector.get(AuthenticationService);
        this.authHttp = this.injector.get(AuthHttp);
        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;

            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.tokenSubject.next(null);

            return this.authHttp.refreshToken()
              .pipe(
                switchMap((newToken: string) => {
                    if (newToken) {
                        this.tokenSubject.next(newToken);
                        this.isRefreshingToken = false;
                        return next.handle(this.addToken(req, newToken));
                    } else {
                      console.log('bounce user out, token not received');
                      return  observableThrowError('Server error');
                      // If we don't get a new token, we are in trouble so logout.
                     // return this.authService.bounceUserOut();
                    }

                }),
                catchError(error => {
                    // If there is an exception calling 'refreshToken', bad news so logout.
                    console.log('bounce user out, error caught in token refresh');
                    return this.authService.bounceUserOut();
                }),
                finalize(() => {
                    this.isRefreshingToken = false;
                }));
        } else {
            return this.tokenSubject.
                pipe(
                filter(token => token != null),
                take(1),
                switchMap(token => {
                    return next.handle(this.addToken(req, token));
                })
                );
        }
    }

    private _ifTokenExpired() {
      this._refreshSubject.subscribe({
        complete: () => {
          this._refreshSubject = new Subject<any>();
        }
      });
      if (this._refreshSubject.observers.length === 1) {
        // Hit refresh-token API passing the refresh token stored into the request
        // to get new access token and refresh token pair
        this.authService.refreshExpiredToken().subscribe(this._refreshSubject);
      }
      return this._refreshSubject;
    }

}
